var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"346f348dd70304bbcb09744cb1343bc081ac5924"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/link";

import * as Sentry from '@sentry/nextjs';
import { rewriteFramesIntegration } from '@sentry/integrations';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        enabled: true,
        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
        ignoreErrors: [ 'ResizeObserver loop limit exceeded' ],
        integrations: [ rewriteFramesIntegration() ],
    });
}
